import { TooltipHost } from '@fluentui/react';
import { FC } from 'react';
import useTimeFormatters from '../../shared/hooks/useTimeFormatters';
import useElapsedTime from '../../shared/hooks/useElapsedTime';

interface IProps {
    timeStart: number | null;
}

const ElapsedTimeTooltipHost: FC<IProps> = ({ timeStart }) => {
    const { formatTimeSpan } = useTimeFormatters();
    const elapsedTime = useElapsedTime(timeStart);
    const elapsedTimeStr = formatTimeSpan(elapsedTime);

    return <TooltipHost content={elapsedTimeStr}>{elapsedTimeStr}</TooltipHost>;
};

export default ElapsedTimeTooltipHost;